import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const logos = [
  "Wall Street Journal",
  "Bloomberg",
  "Fortune",
  "Harvard Business Review",
  "World Economic Forum",
  "CNBC",
  "Financial Times",
  "MIT Technology Review",
  "FranklinCovey",
];

export default function TrustBar() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <section data-testid="trust-bar" ref={ref} className="py-14 md:py-20 border-y border-white/[0.04]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="text-center text-[10px] uppercase tracking-[0.35em] text-[#E8E6E1]/25 mb-10 font-medium">
          Featured In & Speaking At
        </p>
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10">
          {logos.map((logo, i) => (
            <motion.span
              key={logo}
              className="font-['Cormorant_Garamond'] text-sm md:text-base tracking-[0.08em] text-[#E8E6E1]/30 hover:text-[#C4963B]/70 transition-colors duration-500 cursor-default whitespace-nowrap font-medium"
              initial={{ opacity: 0 }}
              animate={inView ? { opacity: 1 } : {}}
              transition={{ duration: 0.6, delay: i * 0.08 }}
            >
              {logo}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
